import type { ClientPropertyArtDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { artFormDefaultValues as DEFAULTS } from "web_myplann/Portfolio/Forms/ArtForm/artFormDefaults";
import type { ArtFormInput } from "web_myplann/Portfolio/Forms/ArtForm/artFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPropertyToArtForm = (
	property: ClientPropertyArtDetailResponseDTO,
): ArtFormInput => ({
	propertyType: property.propertyType ?? DEFAULTS.propertyType,
	customDisposition: property.customDisposition ?? DEFAULTS.customDisposition,
	purchaseDate: parseIsoDate(property.purchaseDate),
	description: property.description ?? DEFAULTS.description,
	value: property.value ?? DEFAULTS.value,
	forInvestments: property.forInvestments ?? DEFAULTS.forInvestments,
});
